import { render } from "./SubscriptionPriceConfigs.vue?vue&type=template&id=0b758368"
import script from "./SubscriptionPriceConfigs.vue?vue&type=script&lang=js"
export * from "./SubscriptionPriceConfigs.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__